export default {"src":"/_next/static/media/circleInfo_24.cf3d61c3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};